import React, { useEffect, useState, useRef } from 'react';
import {
  AiOutlinePlusCircle,
  AiOutlineDelete,
  AiOutlineEdit, AiOutlineCheck, AiOutlineClose
} from 'react-icons/ai';
import Select from 'react-select';
import axios from 'axios';
import { Modal, Button, Table, Form } from "react-bootstrap";
import { CiEdit } from 'react-icons/ci';
import { MdLocalPrintshop } from "react-icons/md";
import logo from '../../../assets/logo.png'
import { useLocation } from 'react-router-dom';
import { useLoading } from '../../../context/LoadingContext';
import ToastNotification from '../../../components/ToastNotification';

function AppraisalRating() {


  const [searchTerm, setSearchTerm] = useState('');
  const [showForm, setShowForm] = useState(false);
  const [user, setUser] = useState([]);
  const { setLoading } = useLoading();
    const [parameter, setParameter] = useState([]);
       const [editingCompanyId, setEditingCompanyId] = useState(null);
  const [formItems, setFormItems] = useState({
    name: '',
    value: '',
    narration: '',
  })


  const [showOptionModal, setShowOptionModal] = useState(false);
  const [newOptionValue, setNewOptionValue] = useState("");
  const [activeDropdown, setActiveDropdown] = useState("");
  const [isEditMode, setIsEditMode] = useState(false);
  const [toast, setToast] = useState({ show: false, message: '', bg: 'success' });
  const showToast = (msg, bg = 'success') => {
    setToast({ show: true, message: msg, bg });
  };

  const [rows, setRows] = useState([
    { col1: "", col2: "", col3: "" }
  ]);

  const handleAddRow = () => {
    setRows([...rows, { col1: "", col2: "", col3: "" }]);
  };

  const handleDeleteRow = (index) => {
    const updatedRows = rows.filter((_, i) => i !== index);
    setRows(updatedRows);
  };

  const handleRowChange = (index, field, value) => {
    const updatedRows = [...rows];
    updatedRows[index][field] = value;
    setRows(updatedRows);
  };




  const handleFormOpen = () => {
    setShowForm(true);
  }


  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormItems(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const fetchRating = async () => {
    setLoading(true)
    try {
      const res = await axios.get('https://api.skyguard.group/api/fetch-rating');
      setParameter(res.data);

    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRating();

  }, []);



  const handleSubmit = async (e) => {
    e.preventDefault();


    if (isEditMode) {
      const sendData = new FormData();

      sendData.append("name", formItems.name);
      sendData.append("value",formItems.value);
      sendData.append("narration", formItems.narration);
   

      try {
        const res = await axios.put(
          `https://api.skyguard.group/api/update-rating/${formItems.id}`,
          sendData,
          { headers: { "Content-Type": "application/json", } }
        );


        showToast('Rating updated successfully!', 'success');
        setShowForm(false);
         fetchRating();
         setIsEditMode(false);

          setFormItems({
          name: '',
          value: '',
          narration: '',

        })

      } catch (err) {
        showToast('Fail to update party!', 'danger');
        console.error("❌ Error:", err.response?.data || err.message);
      }
    } else {
      const sendData = new FormData();
        sendData.append("name", formItems.name);
      sendData.append("value",formItems.value);
      sendData.append("narration", formItems.narration);

      try {
        const res = await axios.post(
          "https://api.skyguard.group/api/add-rating",
          sendData,
          { headers: { "Content-Type": "application/json", } }
        );

        showToast('Rating Added successfully!', 'success');
        setShowForm(false);

         setFormItems({
          name: '',
          value: '',
          narration: '',

        })
        fetchRating();
      } catch (err) {
        showToast('Fail to add  party!', 'danger');
        console.error("❌ Error:", err.response?.data || err.message);
      }
    }

  };

    const handleEdit = (form) => {

    setFormItems({
      id: form.id || '',
      name:form.name || "",
      value: form.value || '',
      narration: form.narration || '',
  
   
    });
    setEditingCompanyId(form.id);
    setIsEditMode(true);
    setShowForm(true);
  };


      const filteredData = parameter.filter(itm =>
    Object.values(itm).some(val =>
      String(val).toLowerCase().includes(searchTerm.toLowerCase())
    )
  )


  return (
   <div className='main-section'>
      <div className='container-fluid dashboard-wrapper p-3 bg-body-secondary'>
        <ToastNotification
          show={toast.show}
          message={toast.message}
          bg={toast.bg}
          onClose={() => setToast({ ...toast, show: false })}
        />
        <h3 className='my-3 fw-bold fs-5 golos'>Appraisal Rating</h3>
        <div className="mb-3 row gx-3 gy-2 align-items-center d-flex justify-content-between">
          <div className="col-12 col-md-5">
            <input
              type="text"
              className="form-control border-0 border-bottom border-dark"
              placeholder="Search..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
          <div className="col-12 col-md-2 d-flex justify-content-end">
            <button className='btn btn-success' onClick={handleFormOpen}>
              <AiOutlinePlusCircle size={20} /> Add
            </button>
          </div>
        </div>

        {showForm && (
          <div className="card p-3 my-3 shadow-sm bg-white border">
            <form onSubmit={handleSubmit}>
              <div className="row">

                <div className='col-12'>
                  <div className="row g-3">

                    <div className="col-12 col-md-4">
                      <label className="form-label fw-medium">Name</label>
                      <input
                        name="name"
                        className="form-control w-100"
                        placeholder="Enter parameter name"
                        value={formItems.name}
                        onChange={handleChange}
                      />

                    </div>
                     <div className="col-12 col-md-4">
                      <label className="form-label fw-medium">Value</label>
                      <input
                        name="value"
                        className="form-control w-100"
                        placeholder="Enter parameter name"
                        value={formItems.value}
                        onChange={handleChange}
                      />

                    </div>

                    <div className="col-12 col-md-4">
                      <label className="form-label fw-medium">Narrration</label>
                      <textarea
                        name='narration'
                        className="form-control w-100"
                        rows={3}
                        placeholder="Enter parameter name"
                        value={formItems.narration}
                        onChange={handleChange}
                      />

                    </div>

                  </div>
                </div>


                <div className='gap-2 d-flex justify-content-center mt-4'>
                  <button type="submit" className='btn btn-success w-10'>
                    {isEditMode ? "Update" : "Save"}

                  </button>
                  <button type='button' className='btn btn-danger w-10 ms-2' onClick={() => {
                    setShowForm(false);

                  }}>
                    Cancel
                  </button>
                </div>


              </div>
            </form>
          </div>

        )}


        <div className='table-responsive shadow p-3 mb-5 bg-body-tertiary rounded my-4'>
          <table className='table table-bordered table-striped table-hover text-center align-middle'>
            <thead className='table-info'>
              <tr>
                <th scope='col'>SN </th>
                  <th scope='col' >Action</th>
                <th scope='col' >Name</th>
                <th scope='col'>Value</th>  
              </tr>
            </thead>

              {filteredData.map((acc, idx) => (
                <tr key={idx} >
                     <td>{idx + 1}</td>
                    <td> 
                       <button
                    className="btn btn-success"
                   
                    onClick={() => handleEdit(acc)}
                  >
                    <CiEdit size={20} />
                  </button>
                  </td>
                  <td> {acc.name} </td>
               <td > {acc.value}</td>
                </tr>
              ))}
          </table>
        </div>


 
      </div>
    </div>
  )
}

export default AppraisalRating